import { render, staticRenderFns } from "./RinvN_Details.vue?vue&type=template&id=cd39c194"
import script from "./RinvN_Details.vue?vue&type=script&lang=js"
export * from "./RinvN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports